import React from 'react';
import { Input } from './ui/input';

export function formatDocBR(digits) {
  const d = digits.replace(/\D/g, '').slice(0, 14);
  if (d.length === 0) return '';
  // CPF (11) or partial
  if (d.length <= 11) {
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0,3)}.${d.slice(3)}`;
    if (d.length <= 9) return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6)}`;
    return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9)}`;
  }
  // CNPJ
  return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8,12)}-${d.slice(12)}`;
}

export default function DocumentInput({ value, onChange, ...rest }) {
  const formatted = formatDocBR(value || '');

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 14);
    onChange(digits);
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={formatted}
      onChange={handleChange}
      placeholder="CPF ou CNPJ"
      {...rest}
    />
  );
}
